import SynthEnvelope from 'instruments/SynthEnvelope.js';
import Tone from 'tone';

export default superclass => class extends superclass  {
    setupEnvelopes() {
        this.ampEnvelope = new SynthEnvelope(
            this.sequencerEngine, this.mixSession, this.context);
        this.ampEnvelope.releaseParameter.automatable = false;
        this.connectSynthToPitchEnvelope();
    }

    setEnvelopes(stepData, ampEnvelope, transpose, voice) {
        let release = stepData && stepData.releaseParameter.get() !== null ?
            stepData.release : ampEnvelope.releaseParameter.getKeyScaledValue(transpose, false);
        if (this.name !== 'C') {
            let toSet = release + window.fuck;
            this.ampEnvelope.releaseParameter.set(toSet, true, true);
        }
        this._setEnvelopes(stepData, this.ampEnvelope, transpose, voice);
        if (stepData && stepData.releaseParameter.get() !== null) {
            ampEnvelope.releaseParameter.set(stepData.release, true, true);
        }
    }

    // used when triggering the synth in Instrument.js
    _setEnvelopes(stepData, ampEnvelope, transpose, voice) {
        // set the attack and release of this trigger
        let release = stepData && stepData.releaseParameter.get() !== null ? stepData.release :
            ampEnvelope.releaseParameter.getKeyScaledValue(transpose);
        voice.envelope.attack = new Tone.Time((1 + ampEnvelope.attackParameter.getKeyScaledValue(transpose)) / 1000.0);
        voice.envelope.decay =  new Tone.Time((1 + ampEnvelope.decayParameter.getKeyScaledValue(transpose)) / 1000.0);
        voice.envelope.sustain = Math.min(ampEnvelope.sustainParameter.getKeyScaledValue(transpose), 0.99);
        voice.envelope.release = new Tone.Time((1 + release) / 1000.0);
    }

    connectSynthToPitchEnvelope() {
        let detunes = this.getDetuneVoices();
        detunes.forEach(x => this.pitchEnvelope.connect(x));
    }

    disconnectSynthFromPitchEnvelope() {
        let detunes = this.getDetuneVoices();
        detunes.forEach(x => this.pitchEnvelope.disconnect(x));
    }

    getDetuneVoices() {
        return this.voices.map(x => x.detune);
    }
}
